export default __webpack_public_path__ + "static/murex-7caf7c80c073e8d7c48203e34ed9b266.jpg";